import { isPlatformBrowser } from '@angular/common';
import { inject, Injectable, PLATFORM_ID } from '@angular/core';
import { Loader } from '@googlemaps/js-api-loader';
import { catchAndLogError } from '@rma/generic/rxjs/operators/catch-and-log-error';
import { rmaShareReplay } from '@rma/generic/rxjs/operators/rma-share-replay';
import { defer, from, map, Observable, of } from 'rxjs';
import { GOOGLE_MAPS_API_KEY } from './google-maps.provider';

@Injectable({ providedIn: 'root' })
export class GoogleMapsScriptService {
  private readonly apiKey = inject(GOOGLE_MAPS_API_KEY, { optional: true });
  private readonly isBrowser = isPlatformBrowser(inject(PLATFORM_ID));

  // resetOnRefCountZero: false — an in-flight load must survive a mid-load unsubscribe, or the next caller builds a second loader
  private readonly mapsLoaded$ = defer(() => {
    if (!this.isBrowser) {
      return of(false);
    }

    const loader = new Loader({
      apiKey: this.apiKey ?? '',
      version: 'weekly',
      libraries: ['places', 'geometry', 'marker'],
    });

    return from(loader.importLibrary('maps')).pipe(map((googleMap) => !!googleMap));
  }).pipe(rmaShareReplay({ resetOnRefCountZero: false }));

  public appendScript(): Observable<boolean> {
    return this.mapsLoaded$.pipe(catchAndLogError<boolean>(of(false)));
  }
}
